module.exports = __webpack_public_path__ + "img/map.3824621a.png";